const directive = {
  inserted(el) {
    el.focus();
  }
};
export {
  directive as default
};
//# sourceMappingURL=Focus.mjs.map
